import { LocalNotifications } from "@capacitor/local-notifications"
import { post } from "../Rest"
import db from "./Database"
import { clearAlarms, updateAlarma } from "./Funciones"
import { getItem, setItem } from "./Storage"

/**
 * Metodos de autenticacion y cierrre de sesión
 */
export const Authentication = {
  loginData: getItem("contcal_login") ? JSON.parse(getItem("contcal_login")||"{}") : undefined,
  login: async (login_obj:any) => {
    const login_res = await post("login",login_obj)
    console.log(login_res)
    if(!login_res.error){
        await clearSession()
        await db.usuarios.put(login_res.usuarios)
        await db.datos_iniciales.put(login_res.datos_iniciales)
        await db.alarmas.put(login_res.alarmas)
        await db.pesos_semanales.bulkPut(login_res.pesos_semanales)
        await updateAlarma()
        setItem("contcal_login","true")
        return {response:true}
    }else{
      return {response:false,error:login_res.error}
    }
  },
  logout: async () => {
    await clearSession()
    Authentication.loginData = undefined
    window.location.href = "/login"
  }
}

/**
 * Elimina los datos de sesión
 */
async function clearSession(){
  window.sessionStorage.clear()
  window.localStorage.clear()
  await db.delete()
  await db.open()
  //Limpiar notificaciones locales
  await clearAlarms()
}